import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-conscious-mobility',
    imports: [TranslateModule],
    templateUrl: './conscious-mobility.component.html',
    styleUrl: './conscious-mobility.component.scss'
})
export class ConsciousMobilityComponent {}
